import Text from "@frog/source/views/Text.view.js"

import pixel from "@frog/source/views/utility/pixel.js"
import * as Objdict from "objdict"

import Colors from "@frog/source/data/colors.js"
import Sizes from "@frog/source/data/sizes.js"

// function stack(position, stack) {
//     if(stack === undefined) {
//         return position
//     }
//     position.stack = stack
//     return position
// }

export default function(stage, space) {
    return {
        "_": Particles(stage, space),
        "stack": 99999999,
        "position": {"x": 0, "y": 0},
    }
}

function Particles(stage, space) {
    if(stage == undefined) return
    if(stage.particles != undefined) {
        return Object.values(stage.particles).map((particle, particleKey) => {
            if(particle.space != space) return
            const position = particle.position
            if(particle.image != undefined) {
                return {
                    "key": "particle/" + particleKey,
                    "position": pixel("particle", particle.position, particle.space),
                    // "stack": particle.stack,
                    "anchor": particle.anchor || {"x": "50%", "y": "50%"},
                    // "anchor": particle.anchor,
                    // "anchor": {"x": "50%", "y": "50%"},
                    "opacity": particle.opacity,
                    "image": particle.image,
                    // "containerName": "nightTilesContainer",
                    // "tint": particle.tint,
                    // "rotation": particle.rotation,
                    // "scale": {
                    //     "x": particle.scale instanceof Object ? particle.scale.x : particle.scale,
                    //     "y": particle.scale instanceof Object ? particle.scale.y : particle.scale,
                    // },
                }
            } else if(particle.text != undefined) {
                return {
                    "key": "particle/" + particleKey,
                    "position": pixel("particle", particle.position || {"x": 0, "y": 0}, particle.space),
                    "anchor": {"x": "50%", "y": "50%"},
                    "opacity": particle.opacity,
                    "_": [
                        Text(particle.text)
                    ]
                    // "anchor": particle.anchor,
                    // "containerName": "nightTilesContainer",
                    // "opacity": particle.opacity,
                    // "tint": particle.tint,
                    // "rotation": particle.rotation,
                    // "scale": {
                    //     "x": particle.scale instanceof Object ? particle.scale.x : particle.scale,
                    //     "y": particle.scale instanceof Object ? particle.scale.y : particle.scale,
                    // },
                }
            // } else if(particle.scale != undefined) {
            //     return {
            //         "type": "circle",
            //         "key": "particle/" + particleKey,
            //         "position": pixel("particle", particle.position, particle.space),
            //         "color": particle.color || 0xFFFFFF,
            //         "radius": particle.scale, // TODO: WHY IS THIS A RADIUS WHEN IT IS RENDERED LIKE A DIAMETER
            //         "anchor": {"x": "50%", "y": "50%"},
            //         // "rotation": particle.rotation,
            //     }
            } else {
                return {
                    "type": "rectangle",
                    "key": "particle/" + particleKey,
                    "position": pixel("particle", particle.position, particle.space),
                    "color": particle.color || 0xFFFFFF,
                    "width": particle.width || particle.scale,
                    "height": particle.height || particle.scale,
                    "anchor": particle.anchor || {"x": "50%", "y": "50%"},
                    "opacity": particle.opacity,
                }
            }
        })
    }
}
